import { render, staticRenderFns } from "./cargoPortLoading.vue?vue&type=template&id=1be4afbc"
import script from "./cargoPortLoading.vue?vue&type=script&lang=js"
export * from "./cargoPortLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports